/**
 * Stock Detail Page - N6 AI Trading Platform
 */

document.addEventListener('DOMContentLoaded', function() {
  var canvas = document.getElementById('stockDetailChart');
  if (!canvas || typeof Chart === 'undefined') return;

  var periodTabs = document.querySelectorAll('.stock-detail__period');
  var chartInstance = null;
  var basePrice = 182.40;

  function getPeriodConfig(period) {
    switch (period) {
      case '1d': return { length: 24, labels: 'hours', volatility: 0.004 };
      case '1m': return { length: 30, labels: 'days', volatility: 0.008 };
      case '3m': return { length: 12, labels: 'weeks', volatility: 0.011 };
      case '1y': return { length: 12, labels: 'months', volatility: 0.014 };
      case '1w':
      default: return { length: 7, labels: 'weekdays', volatility: 0.006 };
    }
  }

  function mulberry32(seed) {
    var t = seed >>> 0;
    return function() {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function hashSeed(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return h >>> 0;
  }

  function buildLabels(length, mode) {
    if (mode === 'hours') {
      var hours = [];
      for (var i = 0; i < length; i++) hours.push((i + 1) + 'h');
      return hours;
    }
    if (mode === 'weekdays') {
      var labels = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
      var week = [];
      for (var j = 0; j < length; j++) week.push(labels[j % 7]);
      return week;
    }
    if (mode === 'weeks') {
      var weeks = [];
      for (var k = 0; k < length; k++) weeks.push('W' + (k + 1));
      return weeks;
    }
    if (mode === 'months') {
      var months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
      return months.slice(0, length);
    }
    var days = [];
    for (var d = 0; d < length; d++) days.push((d + 1).toString());
    return days;
  }

  function buildSeries(period) {
    var cfg = getPeriodConfig(period);
    var rand = mulberry32(hashSeed('AAPL:' + period));
    var series = [];
    var base = basePrice * (0.9 + rand() * 0.08);

    for (var i = 0; i < cfg.length; i++) {
      base += (rand() - 0.48) * (basePrice * cfg.volatility);
      series.push(Math.round(base * 100) / 100);
    }
    series[series.length - 1] = basePrice;

    return { data: series, labels: buildLabels(cfg.length, cfg.labels) };
  }

  function renderChart(period) {
    var series = buildSeries(period);
    if (chartInstance) {
      chartInstance.destroy();
      chartInstance = null;
    }

    var ctx = canvas.getContext('2d');
    var isDark = document.body.classList.contains('theme-dark');
    var gridColor = isDark ? 'rgba(255,255,255,0.08)' : '#E5E7EB';
    var textColor = isDark ? '#9CA3AF' : '#6B7280';
    var lineColor = '#22C55E';
    var gradient = ctx.createLinearGradient(0, 0, 0, canvas.parentElement.clientHeight || 260);
    gradient.addColorStop(0, 'rgba(34, 197, 94, 0.2)');
    gradient.addColorStop(1, 'rgba(34, 197, 94, 0)');

    chartInstance = new Chart(ctx, {
      type: 'line',
      data: {
        labels: series.labels,
        datasets: [{
          data: series.data,
          borderColor: lineColor,
          backgroundColor: gradient,
          fill: true,
          tension: 0.1,
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 4,
          pointHoverBackgroundColor: lineColor,
          pointHoverBorderColor: '#fff',
          pointHoverBorderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function(c) { return '$' + c.parsed.y.toFixed(2); }
            }
          }
        },
        scales: {
          x: {
            display: true,
            grid: { display: false },
            ticks: {
              color: textColor,
              font: { size: 10 },
              maxTicksLimit: 12
            }
          },
          y: {
            display: true,
            grid: { color: gridColor },
            ticks: {
              color: textColor,
              font: { size: 10 },
              callback: function(v) { return '$' + v; }
            }
          }
        }
      }
    });
  }

  var active = document.querySelector('.stock-detail__period.is-active');
  var current = active ? active.getAttribute('data-period') : '1y';
  renderChart(current);

  periodTabs.forEach(function(btn) {
    btn.addEventListener('click', function() {
      periodTabs.forEach(function(t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var period = btn.getAttribute('data-period') || '1y';
      renderChart(period);
    });
  });
});
